module.exports = __webpack_public_path__ + "static/media/amazon_PNG24.f1b7fec6.png";